import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/layouts/docs.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Link = makeShortcode("Link");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "jsbi",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#jsbi",
        "aria-label": "jsbi permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`JSBI`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`import { JSBI } from '@materia/sdk'
// import JSBI from 'jsbi'
`}</code></pre>
    <p>{`The default export from `}<a parentName="p" {...{
        "href": "https://github.com/GoogleChromeLabs/jsbi"
      }}>{`jsbi`}</a>{`.`}</p>
    <h1 {...{
      "id": "bigintish",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#bigintish",
        "aria-label": "bigintish permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`BigintIsh`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`import { BigintIsh } from '@materia/sdk'
// type BigintIsh = JSBI | bigint | string
`}</code></pre>
    <p>{`A union type comprised of all types that can be cast to a JSBI instance.`}</p>
    <h1 {...{
      "id": "chainid",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#chainid",
        "aria-label": "chainid permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`ChainId`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`import { ChainId } from '@materia/sdk'
// enum ChainId {
//   MAINNET = 1,
//   ROPSTEN = 3,
//   RINKEBY = 4,
//   GÖRLI = 5,
//   KOVAN = 42
// }
`}</code></pre>
    <p>{`A enum denominating supported chain IDs.`}</p>
    <h1 {...{
      "id": "tradetype",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#tradetype",
        "aria-label": "tradetype permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`TradeType`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`import { TradeType } from '@materia/sdk'
// enum TradeType {
//   EXACT_INPUT,
//   EXACT_OUTPUT
// }
`}</code></pre>
    <p>{`A enum denominating supported trade types.`}</p>
    <h1 {...{
      "id": "rounding",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#rounding",
        "aria-label": "rounding permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Rounding`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`import { Rounding } from '@materia/sdk'
// enum Rounding {
//   ROUND_DOWN,
//   ROUND_HALF_UP,
//   ROUND_UP
// }
`}</code></pre>
    <p>{`A enum denominating supported rounding options.`}</p>
    <h1 {...{
      "id": "factory_address",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#factory_address",
        "aria-label": "factory_address permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`FACTORY_ADDRESS`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`import { FACTORY_ADDRESS } from '@materia/sdk'
`}</code></pre>
    <p>{`The `}<Link to='/docs/materia/smart-contracts/factory/#address' mdxType="Link">{`factory address`}</Link>{`.`}</p>
    <h1 {...{
      "id": "orchestrator_address",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#orchestrator_address",
        "aria-label": "orchestrator_address permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`ORCHESTRATOR_ADDRESS`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`import { ORCHESTRATOR_ADDRESS } from '@materia/sdk'
`}</code></pre>
    <p>{`The `}<Link to='/docs/materia/smart-contracts/orchestrator/#address' mdxType="Link">{`orchestrator address`}</Link>{`.`}</p>
    <h1 {...{
      "id": "init_code_hash",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#init_code_hash",
        "aria-label": "init_code_hash permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`INIT_CODE_HASH`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`import { INIT_CODE_HASH } from '@materia/sdk'
`}</code></pre>
    <p>{`See `}<Link to='/docs/materia/smart-contracts/factory/#address' mdxType="Link">{`Pair Addresses`}</Link>{`.`}</p>
    <h1 {...{
      "id": "minimum_liquidity",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#minimum_liquidity",
        "aria-label": "minimum_liquidity permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`MINIMUM_LIQUIDITY`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`import { MINIMUM_LIQUIDITY } from '@materia/sdk'
`}</code></pre>
    <p>{`See `}<Link to='/docs/materia/protocol-overview/smart-contracts/#minimum-liquidity' mdxType="Link">{`Minimum Liquidity`}</Link>{`.`}</p>
    <h1 {...{
      "id": "add_liquidity_action_safe_transfer_token",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#add_liquidity_action_safe_transfer_token",
        "aria-label": "add_liquidity_action_safe_transfer_token permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`ADD_LIQUIDITY_ACTION_SAFE_TRANSFER_TOKEN`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`import { ADD_LIQUIDITY_ACTION_SAFE_TRANSFER_TOKEN } from '@materia/sdk'
`}</code></pre>
    <p>{`The safeTransfer addLiquidity operation number used in the orchestrator onERC1155Received callback. The value is 1.`}</p>
    <h1 {...{
      "id": "swap_action_exact_tokens_for_tokens",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#swap_action_exact_tokens_for_tokens",
        "aria-label": "swap_action_exact_tokens_for_tokens permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`SWAP_ACTION_EXACT_TOKENS_FOR_TOKENS`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`import { SWAP_ACTION_EXACT_TOKENS_FOR_TOKENS } from '@materia/sdk'
`}</code></pre>
    <p>{`The swapExactTokensForTokens operation number used in the orchestrator onERC1155Received callback. The value is 2.`}</p>
    <h1 {...{
      "id": "swap_action_tokens_for_exact_tokens",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#swap_action_tokens_for_exact_tokens",
        "aria-label": "swap_action_tokens_for_exact_tokens permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`SWAP_ACTION_TOKENS_FOR_EXACT_TOKENS`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`import { SWAP_ACTION_TOKENS_FOR_EXACT_TOKENS } from '@materia/sdk'
`}</code></pre>
    <p>{`The swapTokensForExactTokens operation number used in the orchestrator onERC1155Received callback. The value is 3.`}</p>
    <h1 {...{
      "id": "swap_action_exact_tokens_for_eth",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#swap_action_exact_tokens_for_eth",
        "aria-label": "swap_action_exact_tokens_for_eth permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`SWAP_ACTION_EXACT_TOKENS_FOR_ETH`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`import { SWAP_ACTION_EXACT_TOKENS_FOR_ETH } from '@materia/sdk'
`}</code></pre>
    <p>{`The swapExactTokensForETH operation number used in the orchestrator onERC1155Received callback. The value is 4.`}</p>
    <h1 {...{
      "id": "swap_action_tokens_for_exact_eth",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#swap_action_tokens_for_exact_eth",
        "aria-label": "swap_action_tokens_for_exact_eth permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`SWAP_ACTION_TOKENS_FOR_EXACT_ETH`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`import { SWAP_ACTION_TOKENS_FOR_EXACT_ETH } from '@materia/sdk'
`}</code></pre>
    <p>{`The swapTokensForExactETH operation number used in the orchestrator onERC1155Received callback. The value is 5.`}</p>
    <h1 {...{
      "id": "insufficientreserveserror",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#insufficientreserveserror",
        "aria-label": "insufficientreserveserror permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`InsufficientReservesError`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`import { InsufficientReservesError } from '@materia/sdk'
`}</code></pre>
    <h1 {...{
      "id": "insufficientinputamounterror",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#insufficientinputamounterror",
        "aria-label": "insufficientinputamounterror permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`InsufficientInputAmountError`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`import { InsufficientInputAmountError } from '@materia/sdk'
`}</code></pre>
    <h1 {...{
      "id": "ieth",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ieth",
        "aria-label": "ieth permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`IETH`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`import { IETH } from '@materia/sdk'
`}</code></pre>
    <p>{`An object whose values are `}<Link to='/docs/materia/smart-contracts/orchestrator/#ieth' mdxType="Link">{`IETH`}</Link>{` `}<Link to='/docs/materia/SDK/token' mdxType="Link">{`Token`}</Link>{` instances, indexed by `}<a parentName="p" {...{
        "href": "#chainid"
      }}>{`ChainId`}</a>{`. IETH is the representation of Ethereum in the EthItem ecosystem.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      